














import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import * as monaco from "monaco-editor";
import {editor} from "monaco-editor";
import IStandaloneDiffEditor = editor.IStandaloneDiffEditor;

@Component
export default class DiffDocuments extends Vue {

    @Prop({required: true})
    value!: any[] | null

    editor: IStandaloneDiffEditor | null = null

    get show() {
        return (this.value?.length || 0) > 0
    }

    get tableName() {
        return this.$route.params.tableName
    }

    @Watch('value')
    onValueChanged() {
        this.$nextTick(() => {
            if (!this.editor) {
                this.editor = monaco.editor.createDiffEditor(this.$refs['jsonDiff'] as any)
            }
            if (this.value) {
                this.editor.setModel({
                    original: monaco.editor.createModel(JSON.stringify(this.value[0], null, 4), 'json'),
                    modified: monaco.editor.createModel(JSON.stringify(this.value[1], null, 4), 'json')
                });
                this.$nextTick(() => {
                    this.editor?.layout()
                })
            }
        })
    }

    @Emit('input')
    close() {
        return null
    }

    onResize() {
        if (this.editor) {
            this.editor.layout()
        }
    }

    mounted() {
        window.addEventListener('resize', this.onResize);
    }

}
